import { CommonModule } from '@angular/common';
import {
    ChangeDetectorRef,
    Component,
    Inject,
    Input,
    NgModule,
    OnInit,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { Cms } from '@impact/data';
import { TranslateModule } from '@ngx-translate/core';
import { map } from 'rxjs/operators';
import { ComponentLoaderModule } from '../../component-loader/component-loader.module';
import { GlobalVehicleDataService } from '../../core/global-vehicle-data.service';
import { SettingsService } from '../../core/settings.service';
import { EnergyRatingModule } from '../../energy-rating/energy-rating.module';
import { Environment, ENVIRONMENT } from '../../environment/environment';
import { LinkModule } from '../../link/link.module';
import { StyleBreakpoints } from '../../models/style-breakpoints';
import { NavigationService } from '../../navigation/navigation.service';
import { RichTextModule } from '../../rich-text/rich-text.module';
import { SidePanelService } from '../../side-panel/side-panel.service';
import { IImageBreakpoints } from '../../utils/responsive-image.component';
import { UtilsModule } from '../../utils/utils.module';
import { NewCarsModule } from '../new-cars.module';

@Component({
    selector: 'app-vehicle-variants-overview-spot',
    templateUrl: './vehicle-variants-overview-spot.component.html',
})
class VehicleVariantsOverviewSpotComponent implements OnInit {
    @Input() data: Cms.VehicleVariantsOverviewSpot;

    campaignPageUrl: string | undefined;
    isB2B$ = this.navigationService.isB2B$;
    isReady = false;
    variants: Cms.VehicleVariantDto[] = [];

    imageBreakpoints: IImageBreakpoints[] = [
        {
            breakpoint: StyleBreakpoints.Xsmall,
            width: 372,
        },
        {
            breakpoint: StyleBreakpoints.Small,
            width: 410,
        },
        {
            breakpoint: StyleBreakpoints.Medium,
            width: 410,
        },
        {
            breakpoint: StyleBreakpoints.Large,
            width: 250,
        },
        {
            breakpoint: StyleBreakpoints.Xlarge,
            width: 250,
        },
    ];

    newVehiclesDisclaimerText$ = this.settingsService
        .get()
        .pipe(map((s) => s.newVehiclesDisclaimerText));

    get vehicleModel() {
        return this.data.vehicleModel;
    }

    constructor(
        private changeDetectorRef: ChangeDetectorRef,
        private globalVehicleDataService: GlobalVehicleDataService,
        private navigationService: NavigationService,
        private settingsService: SettingsService,
        private sidepanelService: SidePanelService,
        @Inject(ENVIRONMENT) private environment: Environment
    ) {}

    ngOnInit() {
        if (!this.vehicleModel) {
            console.error(
                '[BN error: Data not found for "vehicle variants overview spot"]'
            );
            return;
        }

        this.settingsService.get().subscribe(s => {
            this.campaignPageUrl = s.globalPages.campaignPage.url;
            this.changeDetectorRef.markForCheck();
        });

        this.globalVehicleDataService
            .getVehicleModelAndVariants(this.vehicleModel.id)
            .subscribe((modelAndVariants) => {
                this.variants = modelAndVariants.variants.filter((v) => {
                    if (this.environment.site === 'Bjarne Nielsen')
                        return v.showOnBnDk;

                    if (this.environment.site === 'Bilernes Hus')
                        return v.showOnBilernesHusDk;

                    return true;
                });

                this.isReady = true;
                this.changeDetectorRef.markForCheck();
            });
    }

    showLoanSimulator(price: number): void {
        if (price) {
            this.sidepanelService.showLoanCalculatorSidePanel({
                objectPrice: price,
            });
        }
    }

    bookTestDrive() {
        this.sidepanelService.showBookNewCarTestDriveSidePanel(
            this.data.vehicleModel
        );
    }

    exhangeCar() {
        this.sidepanelService.showExhangeCarSidePanel(true);
    }

    getOffer() {
        this.sidepanelService.showGetNewCarOfferSidePanel(
            this.data.vehicleModel
        );
    }
}

@NgModule({
    declarations: [VehicleVariantsOverviewSpotComponent],
    imports: [
        CommonModule,
        TranslateModule.forChild(),
        UtilsModule,
        RichTextModule,
        RouterModule,
        NewCarsModule,
        LinkModule,
        EnergyRatingModule,
        ComponentLoaderModule,
    ],
})
class VehicleVariantsOverviewSpotModule {}

export const LazySpotComponent = VehicleVariantsOverviewSpotComponent;
